import Vue from 'vue'
import Router from 'vue-router'
import AuthLayout from '../components/auth/AuthLayout'
import AppLayout from '../components/admin/AppLayout'

Vue.use(Router)

const EmptyParentComponent = {
  template: '<router-view></router-view>',
}

const demoRoutes = []

export default new Router({
  mode: process.env.VUE_APP_ROUTER_MODE_HISTORY === 'true' ? 'history' : 'hash',
  routes: [
    ...demoRoutes,
    {
      path: '*',
      redirect: { name: 'dashboard' },
    },
    {
      path: '/auth',
      component: AuthLayout,
      children: [
        {
          name: 'login',
          path: 'login',
          component: () => import('../components/auth/login/Login.vue'),
        },
        {
          name: 'signup',
          path: 'signup',
          component: () => import('../components/auth/signup/Signup.vue'),
        },
        {
          path: '',
          redirect: { name: 'login' },
        },
      ],
    },
    {
      name: 'Admin',
      path: '/admin',
      component: AppLayout,
      children: [
        {
          name: 'dashboard',
          path: 'dashboard',
          component: () => import('../components/dashboard/Dashboard.vue'),
          default: true,
        },
        {
          name: 'user',
          path: 'user',
          component: EmptyParentComponent,
          children: [
            {
              name: 'listUser',
              path: 'listUser',
              component: () => import('../components/interview/listUser.vue'),
            },
            {
              name: 'getUser',
              path: 'getUser/:uid',
              component: () => import('../components/interview/user.vue'),
            },
            {
              name: 'listInterview',
              path: 'interview',
              component: () => import('../components/interview/listInterview.vue'),
            },
            {
              name: 'getInterview',
              path: 'getInterview/:roomId',
              component: () => import('../components/interview/interview.vue'),
            },
          ],
        },
        // 题库
        {
          name: 'questionBanks',
          path: 'questionBanks',
          component: EmptyParentComponent,
          children: [
            {
              name: 'listQuestion',
              path: 'listQuestion',
              component: () => import('../components/question/question'),
            },
            {
              name: 'saveQuestion',
              path: 'saveQuestion',
              component: () => import('../components/question/saveQuestion'),
            },
            {
              name: 'updateQuestion',
              path: 'updateQuestion/:id',
              component: () => import('../components/question/saveQuestion'),
            },
            // {
            //   name: 'uploadQuestionExcel',
            //   path: '/uploadQuestionExcel',
            //   component: () => import('../components/question/uploadQuestionExcel'),
            // },
          ],
        },
        // 修改密码功能
        {
          name: 'employee',
          path: 'employee',
          component: EmptyParentComponent,
          children: [
            {
              name: 'resetPassword',
              path: 'resetPassword',
              component: () => import('../components/employee/resetPassword'),
            },
          ],
        },
      ],
    },
  ],
})
